import React from "react";
import { truncate } from "LIB/formatters/text";
import { Link } from "react-router-dom";

export function totalHoursRemaining(part, totalHours) {
  if (!part.total_hours) return 0;

  return Number(part.total_hours) - Number(totalHours);
}

export function totalCyclesRemaining(part, totalCycles) {
  if (!part.total_cycles) return 0;

  return Number(part.total_cycles) - Number(totalCycles);
}

export const inventoryTaggedBy = inventory => {
  if (inventory.repair_order_tagged_by) {
    return (
      <Link to={`/companies/${inventory.repair_order_tagged_by.uuid}`}>
        {truncate(`@ ${inventory.repair_order_tagged_by.name}`, 25)}
      </Link>
    );
  } else if (inventory.tagged_by_uuid) {
    return (
      <Link to={`/companies/${inventory.tagged_by_uuid}`}>
        <span>{truncate(inventory.tagged_by, 25)}</span>
      </Link>
    );
  }

  return <span>{truncate(inventory.tagged_by, 25)}</span>;
};

export const isManagedRepair = inventory =>
  inventory.managed_repair_in_progress || inventory.managed_repair_repaired;



// WEBPACK FOOTER //
// ./app/modules/inventories/helpers.jsx